import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { RBACProvider } from "../context/rbac/RBACContext";

/**
 * Ensures the user is logged in (Firebase session). Does not enforce RBAC.
 */
const AuthenticatedRoute = ({ login, role }) => {
	const location = useLocation();

	if (login === false) {
		return <Navigate to="/login" state={{ redirectTo: location.pathname }} replace />;
	}

	return <RBACProvider role={role} loading={false}>
		<Outlet />
	</RBACProvider>;
};

export default AuthenticatedRoute;
